import { useEffect } from "react";
function isViewportFilled() {
    return document.documentElement.scrollHeight > window.innerHeight + 16;
}
/**
 * Fetches the next page when content does not fill the viewport, so infinite
 * scroll is not blocked waiting for a scroll event that cannot occur.
 */
export function useAutoFillViewport(_a) {
    var enabled = _a.enabled, itemCount = _a.itemCount, hasNextPage = _a.hasNextPage, isFetchingNextPage = _a.isFetchingNextPage, fetchNextPage = _a.fetchNextPage;
    useEffect(function () {
        if (!enabled || !hasNextPage || isFetchingNextPage || itemCount === 0) {
            return;
        }
        var maybeLoadMore = function () {
            if (!isViewportFilled()) {
                fetchNextPage();
            }
        };
        maybeLoadMore();
        var shortDelay = window.setTimeout(maybeLoadMore, 400);
        var afterImagesDelay = window.setTimeout(maybeLoadMore, 1200);
        window.addEventListener("load", maybeLoadMore);
        return function () {
            window.clearTimeout(shortDelay);
            window.clearTimeout(afterImagesDelay);
            window.removeEventListener("load", maybeLoadMore);
        };
    }, [
        enabled,
        itemCount,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    ]);
}
